module.exports = __webpack_public_path__ + "img/bell.022e86ec.svg";